import React from 'react';
import { Helmet } from 'react-helmet-async';
import BookForm from '../components/BookForm';

const BookFormPage = () => {
  return (
    <>
      <Helmet>
        <title>Online Booking | Halo Aesthetic Clinic Richmond Hill</title>
        <meta name="description" content="Schedule your medical aesthetic consultation or treatment online with licensed professionals at Halo Aesthetic Clinic in Richmond Hill, ON." />
        <link rel="canonical" href="https://www.haloaestheticclinic.com/book-form" />
        {/* Event snippet for 网页浏览 conversion page
In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. */}
        <script>
          {`function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-18458381832/6SnuCPThvpcdEIic0uFE',
      'value': 1.0,
      'currency': 'CAD',
      'event_callback': callback
  });
  return false;
}`}
        </script>
      </Helmet>
      <BookForm />
    </>
  );
};

export default BookFormPage;
